import { createTheme } from '@mui/material';

// Option B "refined current": keep the light card identity, tighten it.
// P&L text colors are WCAG 4.5:1 on white (#2E7D32 / #C62828) — never use
// #4CAF50/#F44336 for text, only for fills/chips.
export const pnlColors = { gain: '#2E7D32', loss: '#C62828' };

// Accent + neutral tokens shared across components (swept from per-file literals).
export const accentColors = {
  ticker: '#009688',      // ticker symbols in tables and the candle modal
  spy: '#7B1FA2',         // SPY benchmark overlay line
  binNeutral: '#90A4AE',  // histogram bin straddling zero
};
export const surfaceTints = {
  tableHeader: '#FAFBFD', // DataTable header row
  rowHover: '#f8fafc',    // list-row hover
};
// Shared app-bar background: Home + per-trader header (default strategy branch).
// The color pair is the single source of truth so the full gradient and the
// per-trader header's default branch stay identical by construction.
export const appBarGradientColors = '#42a5f5, #90caf9';
export const appBarGradient = `linear-gradient(135deg, ${appBarGradientColors})`;

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#2196F3', light: '#64B5F6', dark: '#1976D2' },
    secondary: { main: '#9C27B0', light: '#BA68C8', dark: '#7B1FA2' },
    success: { main: pnlColors.gain },
    error: { main: pnlColors.loss },
    background: { default: '#F6F8FB', paper: '#ffffff' },
    text: { primary: '#1a1a2e', secondary: '#6b7280' },
  },
  typography: {
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica", "Arial", sans-serif',
    h4: { fontWeight: 700, letterSpacing: '-0.01em' },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    button: { fontWeight: 600, letterSpacing: '0.01em' },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        'body': { fontVariantNumeric: 'tabular-nums' },
        '@media (prefers-reduced-motion: reduce)': {
          '*': { animationDuration: '0.01ms !important', transitionDuration: '0.01ms !important' },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 4px 16px rgba(15, 23, 42, 0.05)',
          borderRadius: 16,
          border: '1px solid rgba(15, 23, 42, 0.07)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { textTransform: 'none', borderRadius: 10, fontWeight: 600 },
      },
    },
    MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } },
  },
});
